<!-- =========================================================================================
    File Name: VxSidebarItemCard.vue
    Description: Sidebar item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VxSidebarItemCard
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Andy Hoebeke
========================================================================================== -->

<template>
  <div
    :class="[
      { 'vs-sidebar-item-active': activeLink },
      { 'vs-sidebar-item-card-active': activeLink },
      { 'disabled-item pointer-events-none': isDisabled },
    ]"
    class="vs-sidebar--item vs-sidebar--item-card mb-2"
  >
    <router-link
      v-if="to"
      :to="to"
      :class="[{ 'router-link-active': activeLink }]"
      :target="target"
      exact
    >
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon">
      </vs-icon>
      <feather-icon
        :icon="icon"
        :class="{ 'w-3 h-3': iconSmall }"
        v-else
      ></feather-icon>
      <slot></slot>
      <div>
        <span>
          <vs-icon :icon="settlementIcon"></vs-icon>
          <small>{{ displaySettlementType }}</small>
        </span>
        <br />
        <span
          ><small>{{ displayAccountType }}</small></span
        >
      </div>
    </router-link>
    <a v-else :target="target">
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon">
      </vs-icon>
      <feather-icon
        :icon="icon"
        :class="{ 'w-3 h-3': iconSmall }"
        v-else
      ></feather-icon>
      <slot></slot>
      <div>
        <span>
          <vs-icon :icon="settlementIcon"></vs-icon>
          <small>{{ displaySettlementType }}</small>
        </span>
        <br />
        <span
          ><small>{{ displayAccountType }}</small></span
        >
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'VxSidebarItemCard',
  props: {
    icon: {
      default: '',
      type: String,
    },
    iconSmall: {
      default: false,
      type: Boolean,
    },
    iconPack: {
      default: 'material-icons',
      type: String,
    },
    href: {
      default: '#',
      type: String,
    },
    to: {
      default: null,
      type: String,
    },
    index: {
      default: null,
      type: [String, Number],
    },
    featherIcon: {
      default: true,
      type: Boolean,
    },
    target: {
      default: '_self',
      type: String,
    },
    isDisabled: {
      default: false,
      type: Boolean,
    },
    accountType: {
      default: '',
      type: String,
    },
    settlementType: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      activeLink: false,
    };
  },
  computed: {
    settlementIcon() {
      if (this.settlementType === 'tripleabitcoin') {
        return 'account_balance';
      }
      return 'account_balance_wallet';
    },
    displayAccountType() {
      if (this.accountType === 'donation') {
        return 'Donations account';
      } else if (this.accountType === 'ecommerce') {
        return 'E-commerce account';
      } else if (this.accountType === 'invoice') {
        return 'Invoice account';
      }
      return 'unknown';
    },
    displaySettlementType() {
      if (this.settlementType === 'bitcoin') {
        return 'Bitcoin settlement';
      } else if (this.settlementType === 'tripleabitcoin') {
        return 'Local currency settlement';
      }
      return ' - unknown - ';
    },
  },
  watch: {
    $route() {
      this.CheckIsActive();
    },
  },
  methods: {
    CheckIsActive() {
      if (this.to) {
        if (this.to == this.$router.path && this.to) this.activeLink = true;
        else this.activeLink = false;
      }
    },
  },
  updated() {
    this.CheckIsActive();
  },
};
</script>

<style>
.vs-icon {
  vertical-align: middle;
}

.vs-sidebar-item-card-active {
}

.main-menu-sidebar .vs-sidebar--item.vs-sidebar--item-card a {
  background: linear-gradient(
    118deg,
    rgba(var(--vs-primary), 0.2),
    rgba(var(--vs-primary), 0)
  );
  -webkit-box-shadow: none;
  box-shadow: none;
}

.main-menu-sidebar .vs-sidebar--item.vs-sidebar--item-card .router-link-active {
  background: linear-gradient(
    118deg,
    rgba(var(--vs-primary), 1),
    rgba(var(--vs-primary), 0.5)
  );
  font-weight: 400;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
